import { cn } from '@atlas/ui-primitives'
import type { ReactNode } from 'react'

export interface ResolvingRegionProps {
	/** True while every answer inside still belongs to the previous tuple. */
	resolving?: boolean
	children: ReactNode
	className?: string
}

/**
 * Marks a region whose content still answers the PREVIOUS tuple while the next one
 * resolves: dimmed, and `aria-busy` for a reader who cannot see that.
 *
 * A wrapper rather than a flag on each card because "this answer is one tuple behind" is
 * the same fact for every card on the page, and no card can know it. Dimming rather than
 * swapping in skeletons: the previous answer is still the closest thing to the truth, and
 * throwing it away for a round trip is what makes narrowing feel slow.
 */
export function ResolvingRegion({ resolving, children, className }: ResolvingRegionProps) {
	return (
		<div
			aria-busy={resolving || undefined}
			className={cn('transition-opacity duration-200', resolving && 'opacity-50', className)}
		>
			{children}
		</div>
	)
}
